import { useActor } from '../../../components/hooks/useActor';
import { useMeQuery } from '../../../components/hooks/useMeQuery';
import { useGetAccountDetailsQuery } from '../../../queries/useGetAccountDetailsQuery';
import useWizerQuery from '../../training/useWizerQuery';

export enum WizerConnectorStatus {
  Activated = 'Activated',
  NotActivated = 'NotActivated',
}

export const useGetWizerConnectorStatus = () => {
  const { data: me } = useMeQuery();
  const accountId = me?.account?.id;

  const actor = useActor();

  const { data: account } = useGetAccountDetailsQuery({ accountId });
  const { data: wizer } = useWizerQuery({
    accountId: me?.account?.id,
    cbid: account?.cbid,
    email: actor.email,
  });

  return wizer?.dashboardMagicLink
    ? WizerConnectorStatus.Activated
    : WizerConnectorStatus.NotActivated;
};
